'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { Card, CardContent } from '@achra/ui/card';
import { CheckCircle2 } from 'lucide-react';
import Link from 'next/link';
import { useTeamAdminDrive } from '@/modules/shared/hooks/use-team-admin-drive';
function AlreadyCompletedCard() {
  const $ = _c(8);
  const {
    teamAdminDrive: drive
  } = useTeamAdminDrive();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="bg-status-success/15 text-status-success flex size-12 items-center justify-center rounded-full"><CheckCircle2 className="size-5" aria-hidden="true" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex flex-col gap-2"><h2 className="text-2xl font-semibold tracking-tight">Onboarding already completed</h2><p className="text-muted-foreground max-w-md text-sm">Your drive is already set up. Pick where you want to go next.</p></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Button variant="outline" className="w-full min-w-0" asChild={true}><Link href="/my-account">My Account</Link></Button>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = !drive;
  let t4;
  if ($[3] !== drive) {
    t4 = drive ? <a href={drive.driveLink} target="_blank" rel="noopener noreferrer">Explore my Workspace</a> : <span aria-disabled="true">Explore my Workspace</span>;
    $[3] = drive;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = <Card><CardContent className="flex flex-col items-center gap-5 px-8 py-12 text-center">{t0}{t1}<div className="grid w-full max-w-md grid-cols-1 gap-3 sm:grid-cols-2">{t2}<Button className="w-full min-w-0" asChild={true} disabled={t3}>{t4}</Button></div></CardContent></Card>;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}
export { AlreadyCompletedCard };